type Discount = {
  discount_percent: number;
  start_date?: string;
  end_date?: string;
  product_tag: string;
  private?: boolean;
};

export default () => {
  const discounts: Discount[] | null = JSON.parse(
    document.querySelector('[data-product-discounts]').textContent,
  );

  const now = new Date();

  return (
    discounts?.filter((discount) => {
      if (discount.start_date && new Date(discount.start_date) > now) {
        return false;
      }

      if (discount.end_date && new Date(discount.end_date) < now) {
        return false;
      }

      return true;
    }) ?? []
  );
};
